module.exports = __webpack_public_path__ + "img/canal_denuncias.44e6013a.png";